module.exports = "/components/components/timezoneDiscrepancyComponent-bc538b.html";